import React from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';

import Close from '../icons/ai-icon-fat-cross.svg';

const AiButtonClose = ({
	action,
}) => (
	<button
		type="button"
		className="ignite-ai__button-close"
		title="Close"
		onClick={() => action()}
	>
		<SVG
			src={Close}
			className="ignite-ai__icon-close"
		/>
	</button>
);

export default AiButtonClose;

AiButtonClose.propTypes = {
	action: PropTypes.func.isRequired,
};
